module.exports = __webpack_public_path__ + "static/media/register.879346a5.svg";